import { IModelStore } from "./interfaces/IModelStore";
import create from "zustand";

const useModelStore = create<IModelStore>((set) => ({
  booths: [],
  boothURL: "",
  boothSmallURL: "",
  warehouseURL: "",
  boothRotation: Math.PI,
  warehouseRotation: Math.PI / 2,
  setBooths: (booths) => set(() => ({ booths })),
  setBoothURL: (boothURL) => set(() => ({ boothURL })),
  setBoothSmallURL: (boothSmallURL) => set(() => ({ boothSmallURL })),
  setWarehouseURL: (warehouseURL) => set(() => ({ warehouseURL })),
}));

export { useModelStore };
